<template>
    <div class="flat-view">
        <amf-form title="Employers" class="container">
            <div v-if="isInternalUser">My Employers view is available only to Brokers and Plan Administrators</div>
            <div v-if="!isInternalUser">
                <!-- <amf-select v-if="isInternalUser" label='Filters' :options="filters"  v-model="filterId" :show-label="false"></amf-select> -->
                <component v-bind:is="currentComponent" :filter="filterId"></component>
            </div>
        </amf-form>
    </div>
</template>

<script>
import EmployersTable from "../employer/EmployersTable";
import RequestAQuote from "../broker/RequestAQuote";
import CreateNewEmployer from '../employer/CreateNewEmployer';
import RunRenewals from '../workflow/RunRenewals';
import EmployerEdiList from '../edi/EmployerEdiList';
import { amfx } from '../framework/utils/amfx';

export default {
    components: { EmployersTable, EmployerEdiList },
    data() {
        return { 
            filterId: "my",
            filters: [
                { id: "my", name: "My Employers", component:"employers-table" },
                { id: "action-item", name: "With action items assigned to me", component:"employers-table" },
                { id: "fd", name: "All Fiserv Employers", component:"employers-table" },
                { id: "fd-conversion", name: "Fiserv Employers in Conversion", component:"employers-table" }, 
                { id: "fd-edi", name: "All Fiserv EDI Employers", component:"employer-edi-list"}             
            ],
            amfOptions: { noTracking: true }
        }
    },
    computed: {
        ...amfx.map("session", "isInternalUser"),
        menuItems() {
            var buttons = [];
            if(this.can.requestQuote) {
                buttons.push("Request a quote");
            }
            if(this.can.createEmployer) {
                buttons.push("Create New Employer");
            }
            if(this.can.runRenewals) {
                buttons.push("Run Renewals");
            }

            return buttons;
        },
        currentComponent(){
            return this.filters.find(f => f.id == this.filterId).component;
        }
    },
    methods: {
        async createNewEmployer() {
            await modalService.show("createNewEmployer", CreateNewEmployer);
        },
        async requestAQuote() {
            await modalService.show("requestAQuote", RequestAQuote, { 
                title: "Request a quote",
            });
        },
        async runRenewals() {
            await modalService.show("runRenewals", RunRenewals);
        }
    },
}
</script>


// WEBPACK FOOTER //
// src/employer/MyEmployers.vue